import { c as _c } from "react/compiler-runtime";
import { Tabs, TabsList, TabsTrigger } from '@material-bank/mb3-components';
import { ReactNode } from 'react';
export type TabItem = {
  label: string;
  value: string;
  decoration?: ReactNode;
};
type PeriodTabsProps = {
  tabItems: TabItem[];
  onValueChange?: (value: string) => void;
};
export function TabsWrapper(t0) {
  const $ = _c(7);
  const {
    tabItems,
    onValueChange
  } = t0;
  let t1;
  if ($[0] !== tabItems) {
    t1 = tabItems.map(_temp);
    $[0] = tabItems;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <TabsList>{t1}</TabsList>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== onValueChange || $[5] !== t2) {
    t3 = <Tabs onValueChange={onValueChange}>{t2}</Tabs>;
    $[4] = onValueChange;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
function _temp(tabItem) {
  return <TabsTrigger key={tabItem.value} value={tabItem.value} className="gap-1">{tabItem.label}{tabItem.decoration}</TabsTrigger>;
}